import React from 'react';
import { Modal, Box, TextField, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import colors from "assets/theme/base/colors";

const ClosedLostModal = ({
  isOpen,
  onClose,
  comment,
  onCommentChange,
  onSubmit,
 loading = false,
}) => {
  return (
      <Modal
          open={isOpen}
          onClose={loading ? undefined : onClose}
          aria-labelledby="closed-lost-modal"
      >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}>
        <Box className="pearl-popup-header"
          sx={{
            backgroundColor: colors.popupHeader.background,
            px: 4,
            py: 3,
            position: 'sticky',
            top: 0,
            zIndex: 1,
          }}
        >
          <MDTypography 
            id="closed-lost-modal" 
            variant="h6" 
            component="h2"
            sx={{ color: '#FFFFFF' }}
          >
            Closed Lost Reason
          </MDTypography>
        </Box>
        <Box sx={{ p: 4 }}>
          <TextField
            fullWidth
            label="Why was this deal lost?"
            multiline
            rows={4}
            value={comment}
            onChange={(e) => onCommentChange(e.target.value)}
            required
            error={!comment.trim()}
            helperText={!comment.trim() ? "This field is required" : ""}
            sx={{ mb: 3 }}
            disabled={loading}
          />
          <MDBox display="flex" justifyContent="flex-end" gap={2}>
            <MDButton onClick={onClose} variant="outlined" color="secondary" disabled={loading}>
              Cancel
            </MDButton>
            <MDButton
                onClick={() => {
                  if (comment.trim()) onSubmit();
                }}
                variant="gradient"
                color="info"
                disabled={!comment.trim() || loading}
            >
              {loading ? <CircularProgress size={18} color="inherit" /> : 'Submit'}
            </MDButton>
          </MDBox>
        </Box>
      </Box>
    </Modal>
  );
};

export default ClosedLostModal;